export const USER = 'user';
export const USER_INFO = 'user/info';
export const USER_BALANCE_LOGS = 'user/balanceLogs';
export const USER_ADD_BALANCE = 'user/addBalance';
export const USER_GET_REQUEST_LOGS = 'user/requestLogs';
export const USER_GET_REQUEST_LOGS_TYPES = 'user/requestLogsTypes';
export const USER_GET_REQUEST_LOGS_REPORT = 'user/requestLogsReport';
export const USER_GET_LOGS_BY_FILTER = 'user/requestLogsFilter';
